import { Container } from '../../../../../../../components/container/container';
import { Input } from '../../../../../../../components/input/input';
import { MaskedInput } from '../../../../../../../components/input/masked-input';
import { Select } from '../../../../../../../components/select/select';
import { countryArray } from '../../../../../../../helpers/country';
import { phoneMask } from '../../../../../../../helpers/regexp';
import { useManagerStore } from '../../../../../../../store/use-manager-store';
import s from './profile-personal.module.css';
import { useProfilePersonal } from './use-profile-personal';

export const ProfilePersonal = () => {
  const {
    city,
    country,
    firstname,
    lastname,
    region,
    secondname,
    email,
    phone,
    handleUpdateManagerProfile,
    t,
    handleSubmit,
    handleChangeCountry,
  } = useProfilePersonal();
  const { hasAccess } = useManagerStore();
  const isNotAllowed = !hasAccess('profile', ['write']);

  return (
    <div className={s.feature}>
      <Container label={t('Имя')} required>
        <Input
          size="lg"
          value={firstname}
          name="name"
          onChange={(e) =>
            handleUpdateManagerProfile({ first_name: e.currentTarget.value?.trim() })
          }
          onBlur={handleSubmit}
          data-testid="personal-data"
          disabled={isNotAllowed}
        />
      </Container>
      <Container label={t('Фамилия')} required>
        <Input
          size="lg"
          value={lastname}
          name="surname"
          onChange={(e) => handleUpdateManagerProfile({ last_name: e.currentTarget.value?.trim() })}
          onBlur={handleSubmit}
          disabled={isNotAllowed}
        />
      </Container>
      <Container label={t('Отчество')}>
        <Input
          size="lg"
          value={secondname}
          onChange={(e) =>
            handleUpdateManagerProfile({ second_name: e.currentTarget.value?.trim() })
          }
          onBlur={handleSubmit}
          disabled={isNotAllowed}
        />
      </Container>
      <Container label={t('Страна')} required>
        <Select
          options={countryArray}
          size="lg"
          value={country}
          name="country"
          onSelect={handleChangeCountry}
          disabled={isNotAllowed}
        />
      </Container>
      <Container label={t('Область')} required>
        <Input
          size="lg"
          value={region}
          name="region"
          onChange={(e) => handleUpdateManagerProfile({ area: e.currentTarget.value?.trim() })}
          onBlur={handleSubmit}
          disabled={isNotAllowed}
        />
      </Container>
      <Container label={t('Город')} required>
        <Input
          size="lg"
          value={city}
          name="city"
          onChange={(e) => handleUpdateManagerProfile({ city: e.currentTarget.value?.trim() })}
          onBlur={handleSubmit}
          disabled={isNotAllowed}
        />
      </Container>
      <Container label={t('Телефон')} required>
        <MaskedInput
          size="lg"
          value={phone}
          name="phone"
          mask={phoneMask}
          onChange={(e) => handleUpdateManagerProfile({ phone: e?.trim() })}
          onBlur={handleSubmit}
          disabled={isNotAllowed}
        />
      </Container>
      <Container label={t('E-mail')} required>
        <Input
          size="lg"
          value={email}
          name="email"
          onChange={(e) => handleUpdateManagerProfile({ email: e.currentTarget.value?.trim() })}
          onBlur={handleSubmit}
          disabled={isNotAllowed}
        />
      </Container>
    </div>
  );
};
